import { DatasourcedWidgetMetadata } from '@/modules/ta/widget/models/metadata/DataSourcedWidgetMetadata';

export class ChartWidgetMetadata extends DatasourcedWidgetMetadata {
  /**
   * Color of palette of series in a chart.
   *
   * @var {Array}
   */
  chart_palette;

  /**
   * Is actively grouped by multiple columns (NOT drilldown).
   *
   * @var {boolean}
   */
  is_multi_grouped;

  /**
   * Contains y-axis positions.
   *
   * @var {Object}
   */
  move_y_axes;

  /**
   * @var {Array}
   */
  sort_by;

  /**
   * @var {Array}
   */
  sort_order;

  /**
   * @var {Array}
   */
  cumulative_columns;

  /**
   * @var {boolean}
   */
  currency_discrepancy;

  /**
   * @var {boolean}
   */
  show_currency;

  /**
   * @var {Object}
   */
  bullets_per_column;

  /**
   * @var {Object}
   */
  bullets_per_benchmark;

  /**
   * @var {Object}
   */
  bullets_per_instance_benchmark;

  /**
   * @var {Array}
   */
  heatmap_gradient;

  /**
   * @var {Array}
   */
  user_conditional_columns;

  /**
   * @var {Array}
   */
  user_grouped_columns;

  comparison_overwrite;

  comparison_good_override;

  comparison_type;

  type;

  /**
   * @var {Array}
   */
  benchmark;

  constructor(model = {}) {
    super(model);

    this.chart_palette = model.chart_palette || null;
    this.is_multi_grouped = model.is_multi_grouped || false;
    this.move_y_axes =
      model.move_y_axes && Object.keys(model.move_y_axes)?.length ? model.move_y_axes : {};
    // TR-7242: normalize legacy column objects persisted in sort_by to their field name
    this.sort_by = (Array.isArray(model.sort_by) ? model.sort_by : []).map(
      (sort_field) => sort_field?.field ?? sort_field
    );
    this.sort_order = model.sort_order || [];
    this.cumulative_columns = model.cumulative_columns || [];
    this.currency_discrepancy = model.currency_discrepancy;
    this.show_currency = model.show_currency;
    this.bullets_per_column = model.bullets_per_column || {};
    this.bullets_per_benchmark = model.bullets_per_benchmark || {};
    this.bullets_per_instance_benchmark = model.bullets_per_instance_benchmark || {};
    this.heatmap_gradient = model.heatmap_gradient || [];
    this.user_conditional_columns = model.user_conditional_columns || [];
    this.user_grouped_columns = model.user_grouped_columns || [];
    this.comparison_overwrite = model.comparison_overwrite || [];
    this.comparison_good_override = model.comparison_good_override || [];
    this.comparison_type = model.comparison_type || null;
    this.type = model.type;
    this.benchmark = model.benchmark || [];
  }
}
